/**
 * Official pictools.ai pixel-grid mark (multi-tone pink→purple diagonal) —
 * used wherever MixGenie offers cover generation "with pictools.ai".
 */
export function PictoolsMark({ size = 16 }: { size?: number }) {
  const G: Array<[number, number, number, string]> = [
    [6.42, 3.68, 8.14, '#EF569F'], [6.42, 21.01, 9.8, '#ED3193'], [6.42, 38.34, 12.25, '#BD1A8D'],
    [23.75, 3.68, 9.8, '#ED3193'], [23.75, 21.01, 12.25, '#BD1A8D'], [23.75, 38.34, 12.25, '#892890'],
    [41.07, 3.68, 12.25, '#BD1A8D'], [41.07, 21.01, 12.25, '#892890'], [41.07, 38.34, 12.25, '#602D91'],
  ];
  return (
    <svg width={size} height={size} viewBox="3 0 54 54" aria-hidden="true" style={{ display: 'inline-block', verticalAlign: 'middle' }}>
      {G.map(([x, y, s, f], i) => <rect key={i} x={x} y={y} width={s} height={s} fill={f} />)}
    </svg>
  );
}
